import React from "react";
import { Container, Header, Table, Box, SpaceBetween, Link } from "@cloudscape-design/components";
import { ScheduledEventInfo } from "../../services/ScheduledEventsService";
import { AwsUrlBuilder } from "../../utils";
import { LABELS } from "../../constants";

interface ScheduledEventsPanelProps {
  schedules: ScheduledEventInfo[];
}

const renderTarget = (item: ScheduledEventInfo): React.ReactNode => {
  const arn = item.targetArn;
  if (!arn) {
    return LABELS.EMPTY_VALUE;
  }
  const name = AwsUrlBuilder.extractResourceName(arn);
  if (!AwsUrlBuilder.isStateMachineArn(arn)) {
    return name;
  }
  return (
    <Link external href={AwsUrlBuilder.buildStateMachineUrl(arn)} externalIconAriaLabel={LABELS.OPENS_IN_NEW_TAB}>
      {name}
    </Link>
  );
};

const COLUMN_DEFINITIONS = [
  { id: "group", header: LABELS.SCHEDULE_GROUP, cell: (item: ScheduledEventInfo) => item.group },
  { id: "expression", header: LABELS.FIRE_DATE, cell: (item: ScheduledEventInfo) => item.scheduleExpression },
  { id: "state", header: LABELS.STATUS, cell: (item: ScheduledEventInfo) => item.state },
  { id: "target", header: LABELS.TARGET, cell: renderTarget },
];

export const ScheduledEventsPanel: React.FC<ScheduledEventsPanelProps> = ({ schedules }) => (
  <Container
    header={
      <Header variant="h2" counter={`(${schedules.length})`}>
        {LABELS.SCHEDULED_EVENTS}
      </Header>
    }
  >
    <Table
      items={schedules}
      columnDefinitions={COLUMN_DEFINITIONS}
      empty={
        <Box textAlign="center" color="inherit" padding="l">
          <SpaceBetween size="m">
            <b>{LABELS.NO_SCHEDULED_EVENTS}</b>
          </SpaceBetween>
        </Box>
      }
      variant="embedded"
      stripedRows
    />
  </Container>
);
